import React from 'react';
import Modal from 'react-modal';

import FormContextProvider, { FormContext } from '../../../../Context/FormContext';
import Utils from '../../../../Services/Utils';
import ConfigService from "../../../../Services/api/Config";
import Icon from "../../../Common/Icon";
import {ReactComponent as EditIcon} from "../../../../../img/icon-template-edit.svg";
import {ReactComponent as DeleteIcon} from "../../../../../img/icon-delete.svg";
import Condition from "../../../../Models/FieldCondition";
import {ReactComponent as OpenIcon} from "../../../../../img/expand-closed.svg";
import InputSelect from "../../../FormFields/Select";
import ConditionalFields from "../../../../Services/ConditionalFields";
import Button from "../../../Common/Button";
import History from "../../../../Services/History";
import CloneSectionModal from "../CloneSectionModal";
import TagSelect from '../../../Common/NewSelect';
import { TAGS_AVAILABLE, IS_ADMIN } from '../../../../Context/DynamicFormContext';

Modal.setAppElement('html');

function withSectionActions(WrappedComponent) {
  return class extends React.PureComponent {
    constructor(props) {
      super(props);
      this.state = {
        internalSection: { ...this.props.section },
        currentTab: 0,
        currentConditionView: 0,
        currentCondition: null,
        submitted: false,
        showDialog: false,
        modalIsOpen: false,
        cloneSection: {
          label: '',
          errors: []
        },
        oldCondition: null,
      };
      this.editingIndex = -1;
    }

    componentDidMount() {
      History.singleton().register(
        'modalConfig',
        () => {
          this.openModal();
        },
        () => {
          this.closeModal();
        }
      );
    }

    componentWillUnmount() {
      History.singleton().unregister('modalConfig');
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.section !== this.props.section) {
        this.setState({
          internalSection: { ...nextProps.section },
        });
      }
    }

    openModal = (label) => {
      History.singleton().show('modalConfig');
      const { cloneSection } = this.state;
      cloneSection.label = this.getLabelGreatestSection(label);
      this.setState({
        modalIsOpen: true,
        cloneSection: { ...cloneSection }
      });
    };

    closeModal = (event) => {
      History.singleton().close(event);
      this.setState({ modalIsOpen: false });
    };

    closeDialog = () => {
      this.setState({showDialog: false});
    };

    toggleDialog = () => {
      const { showDialog } = this.state;
      this.setState({showDialog: !showDialog});
    };

    getLabelGreatestSection = (sectionLabel) => {
      const { api } = this.props;

      const sectionFields = api.getAllSections();
      let maxNumber = 0;
      let label = sectionLabel.split(' ');
      let check = false;

      if (parseFloat(label[label.length - 1])) {
        label.pop();
      }

      label = label.join(' ');

      sectionFields.map(element => {

        let labelElement = element.label ? element.label.split(' ') : [];
        let labelElementWithOutLast = 0;

        if (labelElement.length > 0) {
          if (parseFloat(labelElement[labelElement.length - 1])) {
            labelElementWithOutLast = labelElement.pop();
          }
        }

        if (Array.isArray(labelElement)) {
          labelElement = labelElement.join(' ');
        }

        if (label === labelElement) {
          check = true;
          if (parseFloat(labelElementWithOutLast) > maxNumber) {
            maxNumber = parseFloat(labelElementWithOutLast);
          }
        }
      });

      if (!maxNumber && check) {
        maxNumber = 2;
        return label + ' ' + maxNumber.toString();
      }

      maxNumber++;
      return label + ' ' + maxNumber.toString();
    };

    changeCloneSectionValue = (field, value) => {
      const { cloneSection } = this.state;
      cloneSection[field] = value;
      this.setState({
        cloneSection: { ...cloneSection }
      });
    };

    changeCloneSectionError = (field, value) => {
      const { cloneSection } = this.state;
      cloneSection.errors[field] = value;
      this.setState({
        cloneSection: { ...cloneSection }
      });
    };

    checkCloneLabelValidation = (value) => {
      const { api } = this.props;
      const sections = api.getAllSections();
      for (const section of sections) {
        if (section.label && section.label.toLowerCase() === value.toLowerCase()) {
          return 'This field can not be repeated.';
        }
      }
      return '';
    };

    handleSubmit = () => {
      const { api, section } = this.props;
      const { internalSection } = this.state;
      api.onSectionValueChange(section.id, internalSection);
      return section.changeValues(internalSection);
    };

    handleDelete = () => {
      const { api, index } = this.props;
      api.onRemoveSection(index);
    };

    handleCancel = () => {
      const { section } = this.props;
      this.setState({ internalSection: { ...section } });
    };

    handleClone = (event) => {
      const { api, index } = this.props;
      const { internalSection, cloneSection, modalIsOpen } = this.state;
      api.onCloneSection(internalSection, index, cloneSection.label);
      if (modalIsOpen) {
        this.closeModal(event);
      }
    };

    changeSectionValue = (field, value) => {
      const { internalSection } = this.state;
      internalSection[field] = value;
      this.setState({
        internalSection: { ...internalSection }
      });
    };

    changeSectionErrors = (field, value) => {
      const { internalSection } = this.state;
      internalSection.errors[field] = value;
      this.setState({
        internalSection: { ...internalSection }
      });
    };

    changeConditionData = (field, value) => {
      const { currentCondition } = this.state;
      if (field === 'conditionField') {
        currentCondition['conditionType'] = null;
        currentCondition.errors['conditionType'] = 'This field is required';
        currentCondition['conditionValue'] = null;
        currentCondition.errors['conditionValue'] = 'This field is required';
      }
      if (field === 'conditionType' && (value.value === 'Empty' || value.value === 'Not Empty' || value.value === 'Is Empty' || value.value === 'Is Not Empty')) {
        delete currentCondition.errors['conditionValue'];
      }
      if(!Array.isArray(value) && Utils.isObject(value) && Utils.isObjectEmpty(value)){
        currentCondition[field] = null;
      }
      else{
        currentCondition[field] = value;
      }
      this.setState({
        currentCondition: { ...currentCondition },
      });
    };

    changeConditionError = (field, value) => {
      const { currentCondition } = this.state;
      currentCondition.errors[field] = value;
      this.setState({
        currentCondition: { ...currentCondition },
      });
    };

    submitCondition = () => {
      const { internalSection, currentCondition } = this.state;
      const index = this.editingIndex;
      if (index !== -1) internalSection.conditions[index] = new Condition(currentCondition);
      else internalSection.conditions = [...internalSection.conditions, new Condition(currentCondition)];
      this.setState({
        internalField: { ...internalSection, conditions: [...internalSection.conditions] },
        currentConditionView: 0,
        currentCondition: null,
        oldCondition: null
      });
      this.editingIndex = -1;
    };

    cancelCondition = () => {
      const { internalSection, oldCondition } = this.state;
      const index = this.editingIndex;
      if (internalSection.conditions && internalSection.conditions.length > 0) {
        if (index !== -1) internalSection.conditions[index] = new Condition(oldCondition);
        else internalSection.conditions = [...internalSection.conditions];
      }
      this.setState({
        internalField: { ...internalSection, conditions: [...internalSection.conditions] },
        currentConditionView: 0,
        currentCondition: null,
        currentRule: null,
        oldCondition: null
      });
      this.editingIndex = -1;
    };

    _getValueLabel = (value) => {
      if (Utils.isNull(value)) return value;
      let result = null;
      if (Array.isArray(value)) {
        let arrayValues = [];
        value.forEach((item) => {
          if (item.label) {
            arrayValues.push(item.label);
          }
          else {
            arrayValues.push(item.value ? item.value : item);
          }
        });
        result = arrayValues.join(',');
      }
      else {
        if (value.label) {
          result = value.label;
        }
        else {
          result = (value.value ? value.value : value);
        }
      }
      return result;
    };

    addOrEditCondition = (condition, editingIndex) => {
      this.setState({
        currentConditionView: 1,
        currentCondition: condition,
        oldCondition: { ...condition }
      });
      if (editingIndex !== undefined) this.editingIndex = editingIndex;
      else this.editingIndex = -1;
    };

    removeCondition = (index) => {
      const { internalSection } = this.state;
      internalSection.conditions.splice(index, 1);
      this.setState({ internalSection: { ...internalSection } });
    };

    renderConditionItem = (item, index) => {
      let value = this._getValueLabel(item.conditionValue);
      const styleTitle = {
        'color': ConfigService.getColor('primaryColor')
      };
      return (
        <li className='Condition_Item' key={ index } style={ styleTitle }>
          <div className='Condition_Item_Text'>
            { item.conditionField.label } { item.conditionType.label } <span className='Bold'>{ value }</span>
          </div>
          <div className='Condition_Item_Actions'>
            <div className='Condition_Item_Actions_Edit' onClick={ () => this.addOrEditCondition(item, index) }>
              <Icon width='16' height='16' color='secondaryColor'>
                <EditIcon alt='icon-template-edit'/>
              </Icon>
            </div>
            <div className='Condition_Item_Actions_Remove' onClick={ () => this.removeCondition(index) }>
              <Icon width='17' height='18' color='secondaryColor'>
                <DeleteIcon alt='icon-delete'/>
              </Icon>
            </div>
          </div>
        </li>
      );
    };

    renderAddCondition = () => {
      const { api } = this.props;
      const { internalSection } = this.state;
      const conditionFields = api.getValidFieldsForConditions(internalSection.id, false, true);
      return (
        <div className='Widget_Form_Conditions'>
          <div className='Conditions_List'>
            Display conditions:
            {internalSection.conditions && (internalSection.conditions.length > 0) && (
              <ul className='Conditions_List_Inner'>
                {internalSection.conditions.map((item, index) => this.renderConditionItem(item, index))}
              </ul>
            )}
            {conditionFields.length > 0 && (
              <div className='Widget_Form_Conditions_Add'
                   onClick={() => this.addOrEditCondition(new Condition())}>
                Add display condition
                <Icon width='15' height='15' color='secondaryColor'>
                  <OpenIcon alt='expand-closed'/>
                </Icon>
              </div>
            ) || (
              <div>Add additional fields to dynamic form before creating a condition</div>
            )}
          </div>
        </div>
      );
    };

    renderDisplayCondition = () => {
      const { api } = this.props;
      const { currentCondition, internalSection } = this.state;
      const conditionFields = api.getValidFieldsForConditions(internalSection.id, false, true);
      return (
        <FormContextProvider>
          <FormContext.Consumer>
            { context => (
              <div className='Condition_Form'>
                <InputSelect label='Show this field when...' required value={ currentCondition.conditionField }
                             options={ conditionFields.map(
                               option => {return { label: option.label, value: option.id };}) }
                             error={ currentCondition.errors['conditionField'] }
                             onError={ (error) => this.changeConditionError('conditionField', error) }
                             onChange={ (v) => this.changeConditionData('conditionField', v) }/>
                { currentCondition.conditionField && (
                  <InputSelect label='Condition...' placeholder='No condition' required value={ currentCondition.conditionType }
                               options={ ConditionalFields.getOptions(
                                 conditionFields.find(item => item.id === currentCondition.conditionField.value)) }
                               error={ currentCondition.errors['conditionType'] }
                               onError={ (error) => this.changeConditionError('conditionType', error) }
                               onChange={ (v) => this.changeConditionData('conditionType', v) }/>
                ) }
                { currentCondition.conditionType && (
                  ConditionalFields.getValueInput(
                    conditionFields.find(item => item.id === currentCondition.conditionField.value),
                    (v) => this.changeConditionData('conditionValue', v),
                    (error) => this.changeConditionError('conditionValue', error),
                    currentCondition,
                  )
                ) }
                <div className='Condition_Form_Footer'>
                  <Button className='Button Button_Small'
                          onClick={ () => context.submit(this.submitCondition, currentCondition.errors) }>Save
                  </Button>
                  <Button className='Button Button_Small Button_Cancel'
                          onClick={ () => context.cancel(this.cancelCondition) }>Cancel
                  </Button>
                </div>
              </div>
            ) }
          </FormContext.Consumer>
        </FormContextProvider>
      );
    };

    renderConditionsTab = () => {
      const { currentConditionView } = this.state;
      switch (currentConditionView) {
        case 0:
          return this.renderAddCondition();
        case 1:
          return this.renderDisplayCondition();
      }
    };
    setLocaleValuesonDefaultParameters = () => {
      const {internalSection} = this.state;
      const {api} = this.props
      internalSection['label'] = api.getFieldsVerbiage(internalSection, 'label');
    };

    renderForm = (renderConfigTab) => {
      const { internalSection } = this.state;
      let tagTypeOptions=[];
       if(TAGS_AVAILABLE && TAGS_AVAILABLE.length>0){
          TAGS_AVAILABLE.forEach((item)=>{
            if(item.allow_use_in_dynamic_forms){
              tagTypeOptions.push({ value: item.id, label: item.display_name || item.tag_name, tag_name: item.tag_name});
            }
            if(!item.allow_use_in_dynamic_forms){
                 if(internalSection.tags_available && internalSection.tags_available.length > 0){
                  internalSection.tags_available.filter((data , index)=>{
                      if(data== item.id){
                        internalSection.tags_available.splice(index, 1);
                      }
                  })
                  }
           }
          })
       }
      return (
        <div className='Widget_Form'>
          {renderConfigTab(internalSection, this.changeSectionValue, this.changeSectionErrors)}
          <hr/>
          {this.renderConditionsTab()}
          <hr/>
          <div className='Tagging_List'>
          Tag:
          <TagSelect
          isMulti={true}
          onValueChange={(v)=>
          this.changeSectionValue('tags_available',v)}
          value={internalSection.tags_available}
          controlShouldRenderValue={false}
          showValuesContainer={true}
          availableTags={tagTypeOptions}
          isAdmin={IS_ADMIN}
        />
          </div>
        </div>
      );
    };

    render() {
      const { internalSection, modalIsOpen, cloneSection, showDialog } = this.state;
      const { section } = this.props;
      return (
        <FormContextProvider>
          <FormContext.Consumer>
            { context => (
              <>
              <WrappedComponent
                { ...this.props }
                { ...this.state }
                internalSection={ internalSection }
                changeSectionValue={ this.changeSectionValue }
                changeSectionErrors={ this.changeSectionErrors }
                renderForm={ this.renderForm }
                handleCancel={ () => context.cancel(this.handleCancel) }
                handleDelete={ this.handleDelete }
                handleSubmit={ () => context.submit(this.handleSubmit, internalSection.errors) }
                handleClone={ () => this.openModal(internalSection.label) }
                toggleDialog={ this.toggleDialog }
                closeDialog={ this.closeDialog }
                showDialog={ showDialog }
                setLocaleValuesonDefaultParameters = {this.setLocaleValuesonDefaultParameters}
              />
              <FormContextProvider>
                <FormContext.Consumer>
                  {contextClone => {
                    const { label, errors } = cloneSection;
                    const { lockLabel } = section;
                    const onCancel = (event) => contextClone.cancel(() => this.closeModal(event));
                    const onConfirm = (event) => contextClone.submit(() => this.handleClone(event), errors);
                    const onChangeText = (v) => this.changeCloneSectionValue('label', v);
                    const onErrorText = (error) => this.changeCloneSectionError('label', error);

                    return (
                      <CloneSectionModal
                        isOpen={modalIsOpen}
                        value={label}
                        lockLabel={lockLabel}
                        onCancel={onCancel}
                        onConfirm={onConfirm}
                        onChangeText={onChangeText}
                        error={errors['label']}
                        onErrorText={onErrorText}
                        textValidator={this.checkCloneLabelValidation}
                      />
                  )}}
                </FormContext.Consumer>
              </FormContextProvider>
              </>
            ) }
          </FormContext.Consumer>
        </FormContextProvider>
      );
    }
  };

}

export default withSectionActions;